// removed by extract-text-webpack-plugin
module.exports = {"container":"T012R81MA _17qxy1jyE","grid":"_2qb_syMsk _3ugGu5boG","corner":"_1o_hT_615 _2fVz2KYnB","header":"_2lqgW-VXX _19xNUQLWh _2OB3nmlqn"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/grid/grid-header/grid-header.css
 ** module id = 680
 ** module chunks = 0
 **/